/** Close the mobile nav overlay (e.g. after page transition). */
export const closeMobileNav = () => {
  const toggle = document.querySelector('.c-nav-toggle');
  const overlay = document.querySelector('.c-nav-overlay');
  if (!toggle || !overlay) return;
  if (overlay.contains(document.activeElement)) {
    toggle.focus();
  }
  toggle.classList.remove('is-active');
  toggle.setAttribute('aria-expanded', 'false');
  overlay.classList.remove('is-active');
  overlay.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('no-scroll');
};

export const initMobileNav = () => {
  const overlay = document.querySelector('.c-nav-overlay');
  if (!overlay) return;

  const getToggle = () => document.querySelector('.c-nav-toggle');

  const close = () => {
    const toggle = getToggle();
    if (overlay.contains(document.activeElement) && toggle) {
      toggle.focus();
    }
    if (toggle) {
      toggle.classList.remove('is-active');
      toggle.setAttribute('aria-expanded', 'false');
    }
    overlay.classList.remove('is-active');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
  };

  const open = () => {
    const toggle = getToggle();
    if (toggle) {
      toggle.classList.add('is-active');
      toggle.setAttribute('aria-expanded', 'true');
    }
    overlay.classList.add('is-active');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
  };

  // Use delegation so one listener works after any DOM changes
  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('.c-nav-toggle');
    if (toggle) {
      event.preventDefault();
      const isOpen = overlay.classList.contains('is-active');
      if (isOpen) close();
      else open();
      return;
    }
    if (overlay.classList.contains('is-active') && !event.target.closest('.c-nav-overlay__nav')) {
      close();
    }
  });

  overlay.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', close);
  });
};
